/**
 * Photos produits détourées.
 *
 * Les packshots du catalogue sont sur fond blanc : posés tels quels dans une
 * étagère, ils y font des carrés blancs. Un script hors ligne les détoure et
 * dépose un manifeste ; s'il est absent ou si un produit n'y figure pas, on
 * retombe simplement sur la photo d'origine.
 */

interface CutoutEntry {
  file: string;
  w?: number;
  h?: number;
}

let manifest: Record<string, CutoutEntry> | null = null;
let chargement: Promise<void> | null = null;

export async function loadCutouts(): Promise<void> {
  if (manifest !== null) return;
  if (!chargement) {
    chargement = fetch('/products/manifest.json')
      .then((response) => (response.ok ? response.json() : {}))
      .then((data: unknown) => {
        manifest = typeof data === 'object' && data !== null ? (data as Record<string, CutoutEntry>) : {};
      })
      .catch(() => {
        // Pas de manifeste : les photos d'origine feront l'affaire.
        manifest = {};
      });
  }
  await chargement;
}

/** URL détourée si elle existe, sinon l'URL fournie. */
export function cutoutUrl(handle: string, repli: string): string {
  return manifest?.[handle]?.file ?? repli;
}

export function hasCutout(handle: string): boolean {
  return Boolean(manifest?.[handle]);
}

/** Utilisé par les tests. */
export function setCutouts(data: Record<string, CutoutEntry> | null): void {
  manifest = data;
  chargement = null;
}
